module.exports = __webpack_public_path__ + "static/media/Matching.fe6ace5d.webp";